import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitTableTitle.module.scss'

type CockpitTableTitleProps = {
  children: ReactNode
  className?: string
}

type CockpitTableColumnTitleProps = CockpitTableTitleProps & {
  group?: boolean
}

export const CockpitTableColumnTitle = ({
  children,
  className,
  group = false,
}: CockpitTableColumnTitleProps) => (
  <span className={cn(styles.column, className, { [styles.columnGroup]: group })}>{children}</span>
)

type CockpitTableRowTitleProps = CockpitTableTitleProps & {
  metric?: boolean
}

export const CockpitTableRowTitle = ({
  children,
  className,
  metric = false,
}: CockpitTableRowTitleProps) => (
  <span className={cn(styles.row, className, { [styles.rowMetric]: metric })}>{children}</span>
)

CockpitTableColumnTitle.displayName = 'CockpitTableColumnTitle'
CockpitTableRowTitle.displayName = 'CockpitTableRowTitle'
